import { z } from 'zod';
import { PreFillableFormTemplateTypeEnum } from '@dealstack/shared/lib/generated';

const CUSTOM_DETAIL_DEFINITION_FIELD_SHAPE = z.object({
	id: z.string().nullish(),
	name: z.string().nonempty(),
	instruction: z.string().nullish(),
	entityType: z.nativeEnum(PreFillableFormTemplateTypeEnum),
	localId: z.string().nullish(),
});

export type ManageCustomDetailDefinitionField = z.infer<
	typeof CUSTOM_DETAIL_DEFINITION_FIELD_SHAPE
>;

export const MANAGE_CUSTOM_DETAILS_DEFINITIONS_FORM_SHAPE = z.object({
	customDefinitions: z.array(CUSTOM_DETAIL_DEFINITION_FIELD_SHAPE),
});

export type ManageCustomDetailsDefinitionsForm = z.infer<
	typeof MANAGE_CUSTOM_DETAILS_DEFINITIONS_FORM_SHAPE
>;
